






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';

interface BusinessLocation {
  label: string;
}

interface BusinessCities {
  label: string;
  locations: BusinessLocation[];
}

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class CoinsCampaignLocationsModal extends Vue {
  @Prop()
  businessCities?: BusinessCities[];

  onClose() {
    eventBus.$emit('closeModal');
  }
}
